import _defineProperty from "/app/node_modules/@babel/runtime/helpers/esm/defineProperty.js";

var _mapping;

import "core-js/modules/es.string.sub.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.error.cause.js";
import "core-js/modules/es.array.concat.js";
// Copyright 2017-2022 @polkadot/types authors & contributors
// SPDX-License-Identifier: Apache-2.0
import { getTypeDef, TypeDefInfo } from '@polkadot/types-create';

function extractSubSingle(_, _ref) {
  var sub = _ref.sub;
  var lookupName = sub.lookupName,
      type = sub.type;
  return extractTypes([lookupName || type]);
}

function extractSubArray(_, _ref2) {
  var sub = _ref2.sub;
  return extractTypes(sub.map(function (_ref3) {
    var lookupName = _ref3.lookupName,
        type = _ref3.type;
    return lookupName || type;
  }));
}

function unhandled(type, _ref4) {
  var info = _ref4.info;
  throw new Error("Unhandled: Unable to create and validate type from ".concat(type, " (info=").concat(TypeDefInfo[info], ")"));
} // we only handle the types with params here


var mapping = (_mapping = {}, _defineProperty(_mapping, TypeDefInfo.BTreeMap, extractSubArray), _defineProperty(_mapping, TypeDefInfo.BTreeSet, extractSubSingle), _defineProperty(_mapping, TypeDefInfo.Compact, extractSubSingle), _defineProperty(_mapping, TypeDefInfo.DoNotConstruct, unhandled), _defineProperty(_mapping, TypeDefInfo.Enum, extractSubArray), _defineProperty(_mapping, TypeDefInfo.HashMap, extractSubArray), _defineProperty(_mapping, TypeDefInfo.Int, unhandled), _defineProperty(_mapping, TypeDefInfo.Linkage, extractSubSingle), _defineProperty(_mapping, TypeDefInfo.Null, unhandled), _defineProperty(_mapping, TypeDefInfo.Option, extractSubSingle), _defineProperty(_mapping, TypeDefInfo.Plain, function (_, typeDef) {
  return typeDef.lookupName || typeDef.type;
}), _defineProperty(_mapping, TypeDefInfo.Range, extractSubSingle), _defineProperty(_mapping, TypeDefInfo.RangeInclusive, extractSubSingle), _defineProperty(_mapping, TypeDefInfo.Result, extractSubArray), _defineProperty(_mapping, TypeDefInfo.Set, extractSubArray), _defineProperty(_mapping, TypeDefInfo.Si, unhandled), _defineProperty(_mapping, TypeDefInfo.Struct, extractSubArray), _defineProperty(_mapping, TypeDefInfo.Tuple, extractSubArray), _defineProperty(_mapping, TypeDefInfo.UInt, unhandled), _defineProperty(_mapping, TypeDefInfo.Vec, extractSubSingle), _defineProperty(_mapping, TypeDefInfo.VecFixed, extractSubSingle), _defineProperty(_mapping, TypeDefInfo.WrapperKeepOpaque, extractSubSingle), _defineProperty(_mapping, TypeDefInfo.WrapperOpaque, extractSubSingle), _mapping);
/** @internal */

export function extractTypes(types) {
  return types.map(function (type) {
    var typeDef = getTypeDef(type);
    return mapping[typeDef.info](type, typeDef);
  });
}